module.exports = __webpack_public_path__ + "images/category_lp/macbook/assessment_achievements/2@2x_53cec6b5f01058cb438ef6c4e7128954.png";